import React from 'react';
import { Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { clearErrors } from '../../actions/general';
import { tokenIsExpired } from '../../actions/authentication';
import Support from '../shared/Support';

export default function Error() {
  const dispatch = useDispatch();
  const errors = useSelector(state => state.general.get('errors'));
  const debug = useSelector(state => state.general.get('debugging'));
  const token = useSelector(state => state.authentication.get('token'));

  if (errors.count() < 1) {
    return  (<></>);
  }

  return (
    <div className="notification is-danger is-light has-text-left">
      {tokenIsExpired(token) && <Redirect to="/init/existing_user" />}
      
      <button onClick={() => dispatch(clearErrors())} className="delete"></button>
      <p className="block">We're sorry, an error has occurred.  Please try the last action again.  If this issue persists, please contact Credit Key support.</p>
      <p className="block has-text-weight-semibold">Below are details about the error:</p>
      <ul>
        {errors.map((e, i) => <li className="block" key={i}>{e}</li>)}
        <li>
          Debugging Data:<br/>
          <strong>public key:</strong> <code style={{ width: '100%' }}>{debug.get('key')}</code><br/>
          <strong>workflow:</strong> {debug.get('workflow')}<br/>
          <strong>action:</strong> {debug.get('action')}<br/>
          <strong>remote id:</strong> {debug.get('uuid')}<br/>
        </li>
      </ul>
      <Support />
    </div>
  )
}
